import React, { useEffect, useRef, useState } from 'react';
import { Box, Link } from '../../atoms';
import withAnalyticsComponent from '@/components/analytics/hocs/withAnalyticsComponent';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';

export type ReadMoreBlockProps = {
  content?: React.ReactNode;
  lines?: number;
  lineHeight?: number;
  readMoreText?: string;
};

const ReadMoreBlock = ({
  content = '',
  lines = 3,
  lineHeight = 26,
  readMoreText = 'Read more',
}: ReadMoreBlockProps) => {
  const [isExtended, setIsExtended] = useState(false);
  const [needsClip, setNeedsClip] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const LinkWithTracking = withAnalyticsComponent(Link, 'Link');

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const isOverflowing = element.scrollHeight > lines * lineHeight;
    setNeedsClip(isOverflowing);
    setIsExtended(!isOverflowing);
  }, [content, lines, lineHeight]);

  if (!content) return null;

  return (
    <Box>
      <Box
        ref={textRef}
        style={{
          maxHeight: isExtended ? 'none' : (lines - 1) * lineHeight,
          overflow: isExtended ? 'visible' : 'hidden',
          position: 'relative',
        }}
      >
        {content}
      </Box>
      {needsClip && !isExtended && (
        <TrackProvider link_name="review read more" link_type="alter component">
          <LinkWithTracking underline onClick={() => setIsExtended(true)}>
            {readMoreText}
          </LinkWithTracking>
        </TrackProvider>
      )}
    </Box>
  );
};

export default ReadMoreBlock;
